import React, { useState, useEffect, Fragment } from "react";
import TextareaAutosize from "react-textarea-autosize";
import {
  Button,
  Input,
  FormGroup,
  Col,
  Row,
  Container,
  Label,
} from "reactstrap";
import ApiCaller from "api/apiCaller";
import Loading from "components/Loading";
import Select from "react-select";

import "./index.css";
import api from "api";
import { SelectOption, ApiResponse } from "model/response";
import { DatasourceListingResponse } from "model/datasource";
import {
  Transformation,
  TransformationDetailResponse,
} from "model/transformation";
import { Popup } from "components/Popup";

interface ModalData {
  isOpen: boolean;
  title: string;
  type: string;
  description: string;
  onPressSubmit: Function;
  onPressCancel: Function;
}

const ScheduleTimeOpstions: Array<SelectOption> = [
  // {
  //   label: "every 15 minutes",
  //   value: "every 15 minutes",
  // },
  // {
  //   label: "every 30 minutes",
  //   value: "every 30 minutes",
  // },
  {
    label: "every week",
    value: "every week",
  },
  {
    label: "every day",
    value: "every day",
  },
  {
    label: "every 12 hours",
    value: "every 12 hours",
  },
  {
    label: "every 8 hours",
    value: "every 8 hours",
  },
  {
    label: "every 6 hours",
    value: "every 6 hours",
  },
  {
    label: "every 5 hours",
    value: "every 5 hours",
  },
  {
    label: "every 4 hours",
    value: "every 4 hours",
  },
  {
    label: "every 3 hours",
    value: "every 3 hours",
  },
  {
    label: "every 2 hours",
    value: "every 2 hours",
  },
  {
    label: "every 1 hours",
    value: "every 1 hours",
  },
];

const WeekdayOptions: Array<SelectOption> = [
  {
    label: "Monday",
    value: "Monday",
  },
  {
    label: "Tuesday",
    value: "Tuesday",
  },
  {
    label: "Wednesday",
    value: "Wednesday",
  },
  {
    label: "Thursday",
    value: "Thursday",
  },
  {
    label: "Friday",
    value: "Friday",
  },
  {
    label: "Saturday",
    value: "Saturday",
  },
  {
    label: "Sunday",
    value: "Sunday",
  },
];

const SourceOptions: Array<SelectOption> = [
  {
    label: "BigQuery",
    value: "google_bigquery"
  },
  {
    label: "Postgres",
    value: "rdbms_postgres"
  }
]

interface TransformationEditProps {
  transformationId?: any,
  onTransformationSaved?: Function,
};

export default function TransformationEdit({
  transformationId,
  onTransformationSaved,
}: TransformationEditProps) {
  const [loading, setLoading] = useState(true);
  const isEdit = transformationId ? true : false;
  const companyId: any = api.getCurrentCompanyId();
  const [currentUser, setCurrentUser] = useState<any>({});
  const [datasourceOptions, setDatasourceOptions] = useState<Array<SelectOption>>([]);
  const [databaseSchemaOptions, setDatabaseSchemaOptions] = useState<Array<SelectOption>>([]);
  const [datasourceId, setDatasourceId] = useState<Number>(0);
  // Schedule Query Data
  const [selectedDatasource, setSelectedDatasource] = useState<SelectOption | null>(null);
  const [selectedSourceType, setSelectedSourceType] = useState<String>('google_bigquery');
  const [selectedSourceDatabaseSchema, setSelectedSourceDatabaseSchema] = useState<String>();
  const [selectedDestinationDatabaseSchema, setSelectedDestinationDatabaseSchema] = useState<String>();
  const [selectedScheduleTime, setSelectedScheduleTime] = useState<SelectOption | null>(null);
  const [selectedWeekday, setSelectedWeekday] = useState<SelectOption | null>(null);
  const [time, setTime] = useState<string>("");
  const [isAppend, setIsAppend] = useState<boolean>(false);
  const [transformationData, setTransformationData] = useState<Transformation>({
    name: "",
    code_name: "",
    dataset_name: "",
    source_type: "google_bigquery",
    datasource_id: 0,
    description: "",
    query: "",
    schedule_time: "",
    table_name: "",
    max_field_name: "",
    primary_field_name: "",
    merge_mode: "MERGE",
    data_linage: true,
    source_database_schema: "",
    destination_database_schema: ""
  });

  const [modalData, setModalData] = useState<ModalData>({
    isOpen: false,
    title: "",
    type: "error",
    description: "",
    onPressCancel: () => {},
    onPressSubmit: () => {},
  });

  const getDatasources = async () => {
    const res:any = await ApiCaller.get(
      `datasource?company_id=${companyId}&is_active=1&include_types=${selectedSourceType}`
    );
    if (res.data && res.data.datasources) {
      const data: DatasourceListingResponse = res?.data
      setDatasourceOptions(data.datasources?.map((datasource) => {
        return {
          label: `${datasource?.name}`,
          value: datasource.id,
        }
      }));
    }
  };

  const getDatasourceDatabaseSchemas = async () => {
    if (datasourceId || selectedDatasource) {
      const selectedDatasourceId = datasourceId ? datasourceId : selectedDatasource?.value
      const res:any = await ApiCaller.get(
        `datasource/${selectedDatasourceId}/database_schema`
      );
      if (res.data && res.data.database_schemas) {
        const data = res?.data
        setDatabaseSchemaOptions(data.database_schemas?.map((database_schema:any) => {
          return {
            label: database_schema,
            value: database_schema,
          }
        }));
      }
    }
  };

  const initData = async () => {
    const user = api.getCurrentUser();
    setCurrentUser(user);
    getDatasources();
    getDatasourceDatabaseSchemas();

    if (isEdit) {
      const resTransformationDetail: ApiResponse = await ApiCaller.get(
        `transformation/${transformationId}`
      );
      if (resTransformationDetail?.status === "ok") {
        const dataTransformationDetail: TransformationDetailResponse = resTransformationDetail?.data;
        setSelectedSourceType(dataTransformationDetail?.transformation.source_type);
        setDatasourceId(dataTransformationDetail.transformation.datasource_id);
        setSelectedSourceDatabaseSchema(dataTransformationDetail.transformation.source_database_schema);
        setSelectedDestinationDatabaseSchema(dataTransformationDetail.transformation.destination_database_schema);

        // Find schedule time
        if (checkingDailyScheduleTime(dataTransformationDetail?.transformation?.schedule_time)) {
          const scheduleTimeList = dataTransformationDetail?.transformation?.schedule_time.split(
            " "
          );
          const scheduleTime = `${scheduleTimeList[0]} ${scheduleTimeList[1]}`;
          const time = `${scheduleTimeList[2]}`;
          const findScheduleTime: any = ScheduleTimeOpstions.find(
            (options) => options.value == scheduleTime
          );
          setSelectedScheduleTime(findScheduleTime);
          setTime(time);
        } else if (
          checkingDailyWeekScheduleTime(
            dataTransformationDetail?.transformation?.schedule_time
          )
        ) {
          const scheduleTimeList = dataTransformationDetail?.transformation?.schedule_time.split(
            " "
          );
          const scheduleTime = `${scheduleTimeList[0]} ${scheduleTimeList[1]}`;
          const weekday = `${scheduleTimeList[2]}`;
          const time = `${scheduleTimeList[3]}`;
          const findScheduleTime: any = ScheduleTimeOpstions.find(
            (options) => options.value == scheduleTime
          );
          setSelectedScheduleTime(findScheduleTime);
          const findWeekday: any = WeekdayOptions.find(
            (options) => options.value == weekday
          );
          setSelectedWeekday(findWeekday);
          setTime(time);
        } else {
          const findScheduleTime: any = ScheduleTimeOpstions.find(
            (options) =>
              options.value ==
              dataTransformationDetail?.transformation?.schedule_time
          );
          setSelectedScheduleTime(findScheduleTime);
        }
        // Set schdule query data
        setTransformationData({
          name: dataTransformationDetail?.transformation?.name,
          code_name: dataTransformationDetail?.transformation?.code_name,
          source_type: dataTransformationDetail?.transformation?.source_type,
          dataset_name: dataTransformationDetail?.transformation?.dataset_name,
          datasource_id: dataTransformationDetail?.transformation?.datasource_id,
          description: dataTransformationDetail?.transformation?.description,
          query: dataTransformationDetail?.transformation?.query,
          schedule_time: dataTransformationDetail?.transformation?.schedule_time,
          table_name: dataTransformationDetail?.transformation?.table_name,
          // write_disposition:
          //   dataTransformationDetail?.transformation?.write_disposition,
          max_field_name: dataTransformationDetail?.transformation?.max_field_name,
          primary_field_name: dataTransformationDetail?.transformation?.primary_field_name,
          merge_mode: dataTransformationDetail?.transformation?.merge_mode,
          region: dataTransformationDetail?.transformation?.region,
          staging_dataset_name: dataTransformationDetail?.transformation?.staging_dataset_name,
          staging_table_name: dataTransformationDetail?.transformation?.staging_table_name,
          source_database_schema: dataTransformationDetail?.transformation?.source_database_schema,
          destination_database_schema: dataTransformationDetail?.transformation?.destination_database_schema,
          data_linage: dataTransformationDetail?.transformation.data_linage
        });
      }
    }
    setLoading(false);
  };

  const handleSourceTypeChange = (selectedValue:any) => {
    setSelectedSourceType(selectedValue?.value);
    setTransformationData({
      ...transformationData,
      ...{ source_type: selectedValue?.value },
    });
  };

  const onSubmit = async () => {
    const { name, dataset_name, table_name } = transformationData;
    if (name === "" || (transformationData.source_type === "google_bigquery" && dataset_name) === "" || table_name === "") {
      setModalData({
        isOpen: true,
        title: "Error",
        type: "error",
        description: "Missing required fields",
        onPressSubmit: () => {
          setModalData({ ...modalData, ...{ isOpen: false } });
        },
        onPressCancel: () => {
          setModalData({ ...modalData, ...{ isOpen: false } });
        },
      });
      return;
    }
    setLoading(true);
    if (isEdit) {
      const res: ApiResponse = await ApiCaller.put(
        `transformation/${transformationId}`,
        transformationData
      );
      if (res?.status === "ok") {
        if (onTransformationSaved) {
          if (res?.data?.transformation) {
            onTransformationSaved(res?.data?.transformation?.id);
          } else {
            onTransformationSaved();
          }
        }
      } else {
        setLoading(false);
        setModalData({
          isOpen: true,
          title: "Error",
          type: "error",
          description: res?.message,
          onPressSubmit: () => {
            setModalData({ ...modalData, ...{ isOpen: false } });
          },
          onPressCancel: () => {
            setModalData({ ...modalData, ...{ isOpen: false } });
          },
        });
      }
    } else {
      const res: ApiResponse = await ApiCaller.post(
        `transformation`,
        transformationData
      );
      if (res?.status === "ok") {
        if (onTransformationSaved) {
          console.log('resres', res?.data?.transformation);
          if (res?.data?.transformation) {
            onTransformationSaved(res?.data?.transformation?.id);
          } else {
            onTransformationSaved();
          }
        }
      } else {
        setLoading(false);
        setModalData({
          isOpen: true,
          title: "Error",
          type: "error",
          description: res?.message,
          onPressSubmit: () => {
            setModalData({ ...modalData, ...{ isOpen: false } });
          },
          onPressCancel: () => {
            setModalData({ ...modalData, ...{ isOpen: false } });
          },
        });
      }
      setLoading(false);
    }
  };

  const checkingDailyScheduleTime = (schedule_time: string) => {
    if (!schedule_time) return false;
    if (schedule_time.includes("every day")) {
      return true;
    } else {
      return false;
    }
  };

  const checkingDailyWeekScheduleTime = (schedule_time: string) => {
    if (!schedule_time) return false;
    if (schedule_time.includes("every week")) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    initData();
  }, [selectedSourceType, datasourceId]);

  useEffect(() => {
    getDatasources();
  }, [selectedSourceType]);

  useEffect(() => {
    getDatasourceDatabaseSchemas();
  }, [selectedDatasource]);

  if (loading) return <Loading />;

  return (
    <div>
      <Popup
        type={modalData?.type}
        isOpen={modalData?.isOpen}
        title={modalData?.title}
        description={modalData?.description}
        onPressSubmit={modalData?.onPressSubmit}
        onPressCancel={modalData?.onPressCancel}
      />
      <Row>
        <Col xs={12}>
          <FormGroup>
            <Label for="source_type"> Source Type </Label>
            <Select
              placeholder=""
              options={SourceOptions}
              defaultValue={SourceOptions[0]}
              value={SourceOptions.filter((sourceOption:any) => sourceOption.value === selectedSourceType)}
              onChange={(selectedOption: any) => {handleSourceTypeChange(selectedOption)}}
            />
          </FormGroup>
        </Col>
        <Col xs={12}>
          <FormGroup>
            {transformationData.source_type === "rdbms_postgres" ?
              <Label for="datasource_id"> Datasource </Label>
              :<Label for="project"> Project </Label>
            }
            <Select
              placeholder=""
              options={datasourceOptions}
              value={datasourceOptions.filter((datasource:any) => datasource.value === transformationData.datasource_id)}
              onChange={(selectedOption: any) => {
                setSelectedDatasource(selectedOption);
                setTransformationData({
                  ...transformationData,
                  ...{ datasource_id: selectedOption?.value },
                });
              }}
            />
          </FormGroup>
        </Col>
        <Col xs={12}>
          <FormGroup>
            <Label for="data_linage"> Enable data linage </Label>{"  "}
            <input
              type="checkbox"
              onChange={e => setTransformationData({...transformationData, ...{data_linage: e.target.checked}})}
              // value={transformationData.data_linage}
              checked={transformationData.data_linage}
            />
          </FormGroup>
        </Col>
        <Col xs={12}>
          <FormGroup>
            <Label>Transformation name (*)</Label>
            <Input
              type="text"
              value={transformationData?.name}
              onChange={(e) => {
                setTransformationData({
                  ...transformationData,
                  ...{ name: e.target.value },
                });
              }}
            />
          </FormGroup>
        </Col>
        <Col xs={12}>
          <FormGroup>
            <Label>Code name (*)</Label>
            <Input
              type="text"
              placeholder="some_code_name_here"
              value={transformationData?.code_name}
              onChange={(e) => {
                setTransformationData({
                  ...transformationData,
                  ...{ code_name: e.target.value },
                });
              }}
            />
          </FormGroup>
        </Col>
        <Col xs={12}>
          <FormGroup>
            <Label>Description (*)</Label>
            <TextareaAutosize
              className="form-control"
              type="textarea"
              minRows={2}
              value={transformationData?.description}
              onChange={(e) => {
                setTransformationData({
                  ...transformationData,
                  ...{ description: e.target.value },
                });
              }}
            />
          </FormGroup>
        </Col>
        {transformationData.source_type === "google_bigquery" &&
          <Col xs={12}>
            <FormGroup>
              <Label>Processing location</Label>
              <Input
                type="text"
                placeholder="If left blank, default region of datasource will be used"
                value={transformationData?.region}
                onChange={(e) => {
                  setTransformationData({
                    ...transformationData,
                    ...{ region: e.target.value },
                  });
                }}
              />
            </FormGroup>
            <FormGroup>
              <Label>Destination Dataset Name (*)</Label>
              <Input
                type="text"
                value={transformationData?.dataset_name}
                onChange={(e) => {
                  setTransformationData({
                    ...transformationData,
                    ...{ dataset_name: e.target.value },
                  });
                }}
              />
            </FormGroup>
          </Col>
        }
        {transformationData.source_type === "rdbms_postgres" &&
          <Col xs={12}>
            <FormGroup>
              <Label for="source_database_schema"> Source Database Schema </Label>
              <Select
                placeholder=""
                options={databaseSchemaOptions}
                value={databaseSchemaOptions.filter((database_schema:any) => database_schema.value === transformationData.source_database_schema)}
                onChange={(selectedOption: any) => {
                  setSelectedSourceDatabaseSchema(selectedOption);
                  setTransformationData({
                    ...transformationData,
                    ...{ source_database_schema: selectedOption?.value },
                  });
                }}
              />
            </FormGroup>
            <FormGroup>
              <Label for="destination_database_schema"> Destination Database Schema </Label>
              <Select
                placeholder=""
                options={databaseSchemaOptions}
                value={databaseSchemaOptions.filter((database_schema:any) => database_schema.value === transformationData.destination_database_schema)}
                onChange={(selectedOption: any) => {
                  setSelectedDestinationDatabaseSchema(selectedOption);
                  setTransformationData({
                    ...transformationData,
                    ...{ destination_database_schema: selectedOption?.value },
                  });
                }}
              />
            </FormGroup>
          </Col>
        }
        <Col xs={12}>
          <FormGroup>
            <Label>Destination Table Name (*)</Label>
            <Input
              type="text"
              value={transformationData?.table_name}
              onChange={(e) => {
                setTransformationData({
                  ...transformationData,
                  ...{ table_name: e.target.value },
                });
              }}
            />
          </FormGroup>
        </Col>
        <Col xs={12}>
          <FormGroup>
            <Label>Max field name (*)</Label>
            <Input
              type="text"
              value={transformationData?.max_field_name}
              onChange={(e) => {
                setTransformationData({
                  ...transformationData,
                  ...{ max_field_name: e.target.value },
                });
              }}
            />
          </FormGroup>
        </Col>
        <Col xs={12}>
          <FormGroup>
            <Label>Primary field name (*)</Label>
            <Input
              type="text"
              value={transformationData?.primary_field_name}
              onChange={(e) => {
                setTransformationData({
                  ...transformationData,
                  ...{ primary_field_name: e.target.value },
                });
              }}
            />
          </FormGroup>
        </Col>
        <Col xs={12}>
          <FormGroup>
            <Label>Merge Mode (*)</Label>
            <Input
              type="select"
              value={transformationData?.merge_mode}
              onChange={(e) => {
                setTransformationData({
                  ...transformationData,
                  ...{ merge_mode: e.target.value },
                });
              }}
            >
              <option value="">--- Select a merge mode ---</option>
              <option value="MERGE">Merge (Upsert)</option>
              <option value="MERGE_FROM_STAGING">
                Merge from Staging (Upsert)
              </option>
              <option value="SAVE_RESULT_TO_TABLE">Save result to table</option>
              <option value="EXECUTE">Execute SQL</option>
            </Input>
          </FormGroup>
        </Col>
        {transformationData?.merge_mode === "MERGE_FROM_STAGING" && (
          <Fragment>
            <Col xs={12}>
              <FormGroup>
                <Label>Staging Dataset Name (*)</Label>
                <Input
                  type="text"
                  value={transformationData?.staging_dataset_name}
                  onChange={(e) => {
                    setTransformationData({
                      ...transformationData,
                      ...{ staging_dataset_name: e.target.value },
                    });
                  }}
                />
              </FormGroup>
            </Col>
            <Col xs={12}>
              <FormGroup>
                <Label>Staging Table Name (*)</Label>
                <Input
                  type="text"
                  value={transformationData?.staging_table_name}
                  onChange={(e) => {
                    setTransformationData({
                      ...transformationData,
                      ...{ staging_table_name: e.target.value },
                    });
                  }}
                />
              </FormGroup>
            </Col>
          </Fragment>
        )}
        <Col xs={12}>
          <FormGroup>
            <Label for="project"> Run schedule (*)</Label>
            <Select
              placeholder=""
              options={ScheduleTimeOpstions}
              value={selectedScheduleTime}
              onChange={(selectedOption: any) => {
                setSelectedScheduleTime(selectedOption);
                const newScheduleTime = checkingDailyWeekScheduleTime(
                  selectedOption?.value
                )
                  ? `${selectedOption?.value} ${selectedWeekday?.value} ${time}`
                  : `${selectedOption?.value} ${time}`;
                setTransformationData({
                  ...transformationData,
                  ...{ schedule_time: newScheduleTime },
                });
                if (
                  !checkingDailyScheduleTime(selectedOption?.value) &&
                  !checkingDailyWeekScheduleTime(selectedOption?.value)
                ) {
                  setTime("");
                  setSelectedWeekday(null);
                }
                if (checkingDailyScheduleTime(selectedOption?.value)) {
                  setSelectedWeekday(null);
                }
              }}
            />
          </FormGroup>
        </Col>
        <Col xs={12}>
          {checkingDailyWeekScheduleTime(selectedScheduleTime?.value) && (
            <FormGroup>
              <Label for="project"> Weekday (*)</Label>
              <Select
                placeholder=""
                options={WeekdayOptions}
                value={selectedWeekday}
                onChange={(selectedOption: any) => {
                  setSelectedWeekday(selectedOption);
                  const newScheduleTime = `${selectedScheduleTime?.value} ${selectedOption?.value} ${time}`;
                  setTransformationData({
                    ...transformationData,
                    ...{ schedule_time: newScheduleTime },
                  });
                }}
              />
            </FormGroup>
          )}
        </Col>
        <Col xs={12}>
          {(checkingDailyScheduleTime(selectedScheduleTime?.value) ||
            checkingDailyWeekScheduleTime(selectedScheduleTime?.value)) && (
            <FormGroup>
              <Label for="schedule_time">At Time (*)</Label>
              <Input
                type="time"
                id="exampleTime"
                value={time}
                onChange={(e) => {
                  setTime(e.target.value);
                  const newScheduleTime = checkingDailyWeekScheduleTime(
                    selectedScheduleTime?.value
                  )
                    ? `${selectedScheduleTime?.value} ${selectedWeekday?.value} ${e.target.value}`
                    : `${selectedScheduleTime?.value} ${e.target.value}`;
                  setTransformationData({
                    ...transformationData,
                    ...{ schedule_time: newScheduleTime },
                  });
                }}
              />
            </FormGroup>
          )}
        </Col>
        <Col xs={12}>
          <FormGroup>
            <Label>SQL (*)</Label>
            <TextareaAutosize
              className="form-control"
              type="textarea"
              minRows={2}
              value={transformationData?.query}
              onChange={(e) => {
                setTransformationData({
                  ...transformationData,
                  ...{ query: e.target.value },
                });
              }}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <div style={styles.controls}>
            <Button color="primary" onClick={onSubmit}>
              {isEdit ? "Save changes" : "Create"}
            </Button>{" "}
          </div>
        </Col>
      </Row>
    </div>
  );
}

const styles: { [name: string]: React.CSSProperties } = {
  controls: {
    marginTop: 12,
    marginBottom: 12,
  },
  info: {
    marginTop: 12,
    marginBottom: 12,
  },
  infoHeading: {
    fontWeight: 700,
  },
  queryContainer: {
    marginTop: 12,
  },
};
